import { PrimaryClientType } from 'api/types/entity';
import { GridFields } from 'components';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Field, useField } from 'modules/operation/common/forms/operationForm';
import { useOperationFormContentContext } from 'modules/operation/common/providers/OperationFormContentProvider';

import { Section } from '../../Section';

import { ClientField } from './ClientField';
import { OrderField } from './OrderField';
import { OrderFields } from './OrderFields';

export const ClientsOrderSection = () => {
  const { t } = useTranslation();

  const { canChangeClientAndOrder, brokerTimezoneOffset, mode } =
    useOperationFormContentContext();

  const isEditable = useIsFormEditable();

  const { helpers: clientHelpers } = useField('client');
  const { helpers: orderHelpers } = useField('order');

  const onChangeClientType = () => {
    clientHelpers.setValue(undefined);
    orderHelpers.setValue(undefined);
  };

  return (
    <Section
      datax="operation-form-basic-information-section"
      title={t('operation.sections.clientsOrderSection.title')}
    >
      <GridFields>
        <Field.Autocomplete
          fullWidth
          showRequiredMark
          disabled={isEditable && !canChangeClientAndOrder}
          label={t(
            'operation.sections.clientsOrderSection.fields.clientType.label'
          )}
          name="clientType"
          optionLabelKey="label"
          options={Object.values(PrimaryClientType).map((v) => ({
            label: t(`primaryClientType.${v}`),
            value: v,
          }))}
          optionValueKey="value"
          placeholder={t(
            'operation.sections.clientsOrderSection.fields.clientType.placeholder'
          )}
          variant="select"
          onChange={onChangeClientType}
        />
        <ClientField
          disabled={isEditable && !canChangeClientAndOrder}
          mode={mode}
        />
        <OrderField disabled={isEditable && !canChangeClientAndOrder} />
        <OrderFields brokerTimezoneOffset={brokerTimezoneOffset} mode={mode} />
      </GridFields>
    </Section>
  );
};
